/* nsh-quiz-v13q.js - question side of v13 (2026-10-06; v13.14b 2026-10-22: finish() wrapper runs once per call chain - boot() can wrap
   finish a second time after another layer (v10b gate, return.js) wrapped it, and the nested copy found __nshDPending already taken and
   set __nshD=null (d= missing from the URL / share link / tracking); a nested copy now passes straight through, and an empty pending
   value is recomputed from the seq layer's stored taps (window.NSH_seqDetail); v13.14 2026-10-21: during a run of the new display order (window.__nshSeqRun, assets/nsh-quiz-seq.js) finish() shows no detail screens - seq asked them after the concern screens - and only saves window.__nshDPending (same nshQuizD / __nshD as before); v13.21 2026-10-10: sharer code nshUid (8 chars base36, crypto.getRandomValues) made on the first finished quiz, window.NSH_uid(), shareUrl() carries by=<uid>; v13.20 2026-10-09: EN option labels of q16/q17 pass through ucf()). ASCII only; Korean comes from NSH_V13 (nsh-quiz-v13-ko.js).
   1) Question 16 (concern) gets nine options: tone T, spots C, pores A, blackheads K, wrinkles B, trouble G, redness F, dark circles E, none ''.
      The option list is rebuilt after v11 reshaped the questions. v8b2 (two picks, "next" button) keeps working: it only needs the option without a concern code to be "none".
   2) Question 17: a detail screen per picked concern that has one (spots, dark circles), shown by wrapping finish() so the
      engine's question list and the share-link answer string stay untouched. Multi-select bits 1/2/4, "do not know" alone = 0.
      Answers live in window.__nshD {C:bits, E:bits}, localStorage nshQuizD {a, d}, and the share link (&d=C3E0).
   3) shareUrl() carries the detail. Tracking: quiz_q for each detail screen; quiz_complete gets `detail` (track v4.3). */
(function(){
  if(window.__NSH_V13Q)return;window.__NSH_V13Q=1;
  var W=window,D=document;
  function X(){return W.NSH_V13||null}
  /* v13.13: ko/en/ja. Q is the list on screen (a localized copy on /en and /ja), Q_KO the source; both get the new options. */
  function byIdIn(A,id){try{for(var i=0;i<A.length;i++)if(A[i]&&A[i].id===id)return A[i]}catch(e){}return null}
  function byId(id){var a=null,b=null;try{a=byIdIn(Q_KO,id)}catch(e){}try{b=byIdIn(Q,id)}catch(e){}return b||a}
  function allById(id){var out=[];try{var a=byIdIn(Q_KO,id);if(a)out.push(a)}catch(e){}try{var b=byIdIn(Q,id);if(b&&out.indexOf(b)<0)out.push(b)}catch(e){}return out}
  function ucf(t){t=String(t||'');var x=X();return x&&x.lang==='en'?t.charAt(0).toUpperCase()+t.slice(1):t}
  function log(ev,o){try{if(typeof logEvent==='function')logEvent(ev,o||{})}catch(e){}}
  /* v13.21: sharer code. Persistent per browser (localStorage nshUid); only this code goes into links (by=), never an email */
  function uidGet(){var v='';try{v=localStorage.getItem('nshUid')||''}catch(e){}if(!/^[0-9a-z]{8}$/.test(v))v=W.__nshUid||'';return /^[0-9a-z]{8}$/.test(v)?v:''}
  function uidMake(){
    var v=uidGet();if(v)return v;
    var C=W.crypto||W.msCrypto;if(!C||!C.getRandomValues)return '';
    var s='',b=new Uint8Array(16);
    while(s.length<8){C.getRandomValues(b);for(var i=0;i<b.length&&s.length<8;i++)if(b[i]<252)s+=(b[i]%36).toString(36)}
    W.__nshUid=s;try{localStorage.setItem('nshUid',s)}catch(e){}
    return s;
  }
  W.NSH_uid=uidGet;

  /* ---- 1) nine options ---- */
  function reshape(){
    var x=X();if(!x||!W.__NSH_V11_Q)return false;
    var cn=byId('concern');if(!cn)return false;
    var all=allById('concern');if(all.every(function(q){return q.o&&q.o.length===x.q16.length&&q.o[0]&&q.o[0].concern===x.q16[0][0]&&q.o[0].t===ucf(x.q16[0][1])}))return true;
    all.forEach(function(q){q.o=x.q16.map(function(p){return {t:ucf(p[1]),s:{},concern:p[0]}})});
    try{if(typeof CONCERN_TOPICS!=='undefined'){if(!CONCERN_TOPICS.T)CONCERN_TOPICS.T={main:['tone','melasma']};if(!CONCERN_TOPICS.K)CONCERN_TOPICS.K={main:['pores-blackheads']};if(!CONCERN_TOPICS.C)CONCERN_TOPICS.C={main:['melasma','tone']};if(!CONCERN_TOPICS.A)CONCERN_TOPICS.A={main:['pores-blackheads'],sub:['acne-care']}}}catch(e){}
    try{if(typeof __applyLocale==='function')__applyLocale()}catch(e){}
    /* a restored result (own link / shared link) may have been replayed against the old option list before this ran: re-read the concern from the answer and c2 from the URL, then redraw */
    try{var li=Q.length-1,ai=answers[li];if(ai!==undefined&&ai!==null&&ai!==''&&typeof acc==='object'&&acc){var oo=cn.o[+ai];acc.concern=(oo&&oo.concern)||''}}catch(e){}
    try{var c2=new URL(location.href).searchParams.get('c2');if(c2){var t=null;for(var r=0;r<cn.o.length;r++)if(cn.o[r].concern===c2){t=r;break}if(t!==null&&c2!==String(acc.concern||'').charAt(0))W.__nshC2=t}}catch(e){}
    try{if(W.NSH_V13_API&&D.querySelector('#nshV9 .v13-root'))setTimeout(function(){W.NSH_V13_API.redraw()},0)}catch(e){}
    return true;
  }

  /* ---- 2) detail screens ---- */
  function pickedCodes(){
    var out=[];
    try{var c1=String(acc.concern||'').charAt(0);if(c1)out.push(c1)}catch(e){}
    try{var i2=W.__nshC2;if(i2!==null&&i2!==undefined){var lq=Q[Q.length-1],o=lq&&lq.o&&lq.o[i2];if(o&&o.concern&&out.indexOf(o.concern)<0)out.push(o.concern)}}catch(e){}
    return out;
  }
  function detailConcerns(){
    var x=X(),out=[];
    pickedCodes().forEach(function(code){var k=x.codeKey[code],K=k&&x.concerns[k];if(K&&K.q17)out.push(K)});
    return out;
  }
  function ansStr(){try{return answers.slice(0,Q.length).join('')}catch(e){return ''}}
  function save(d){
    W.__nshD=d;
    try{localStorage.setItem('nshQuizD',JSON.stringify({a:ansStr(),d:d}))}catch(e){}
  }
  function shownTotal(){try{if(typeof W.NSH_shownTotal==='function')return W.NSH_shownTotal()}catch(e){}return Q.length}

  function screen(K,n,total,done){
    var x=X(),wrap=D.getElementById('opts'),qt=D.getElementById('qText'),cnt=D.getElementById('count'),fill=D.getElementById('fill'),back=D.getElementById('backBtn');
    if(!wrap||!qt)return done(null);
    W.__nshDetailOpen=1;try{locked=true}catch(e){}
    if(!W.__nshBackBase&&typeof W.back==='function'){W.__nshBackBase=W.back;W.back=function(){if(W.__nshDetailOpen){W.__nshDetailOpen=0;try{locked=false}catch(e){}if(W.__nshRestoreTotal)W.__nshRestoreTotal();try{render()}catch(e){}return}return W.__nshBackBase.apply(this,arguments)}}
    var pad=function(v){return String(v).padStart(2,'0')};
    if(cnt){var left=total-n+1;cnt.textContent=(left<=1?x.q17last:x.q17more)||(pad(n)+' / '+pad(total))}
    if(fill)fill.style.width=((n-1)/total*100)+'%';
    qt.textContent=ucf(x.q17.replace('{name}',K.name));
    wrap.innerHTML='';
    var sel={},btns=[],opts=K.q17.map(ucf);opts.push(ucf(x.q17unknown));
    var nx=D.createElement('button');nx.className='btn-bar';nx.type='button';nx.disabled=true;nx.textContent=x.q17next;nx.style.marginTop='14px';
    opts.forEach(function(t,i){
      var b=D.createElement('button');b.className='opt';b.type='button';b.setAttribute('data-v13q','1');
      b.innerHTML='<span class="k">'+(i+1)+'</span><span class="ot">'+t.replace(/&/g,'&amp;').replace(/</g,'&lt;')+'</span>';
      b.onclick=function(){
        var none=(i===opts.length-1);
        if(none){sel={};sel[i]=1}else{delete sel[opts.length-1];if(sel[i])delete sel[i];else sel[i]=1}
        btns.forEach(function(z,j){z.classList.toggle('sel',!!sel[j])});
        nx.disabled=!Object.keys(sel).length;
      };
      btns.push(b);wrap.appendChild(b);
    });
    nx.onclick=function(){
      var bits=0;Object.keys(sel).forEach(function(j){j=+j;if(j<opts.length-1)bits|=(1<<j)});
      log('quiz_q',{q:n,id:'detail_'+K.code,pick:bits,qv:13});
      done(bits);
    };
    wrap.appendChild(nx);
    if(back){back.style.visibility='visible';back.onclick=function(){try{W.back()}catch(e){}}}
    var c=D.getElementById('qcard');if(c){c.classList.remove('rise');void c.offsetWidth;c.classList.add('rise')}
    try{if(W.matchMedia&&W.matchMedia('(max-width:880px)').matches)W.scrollTo(0,Math.round((W.innerHeight||800)*0.24))}catch(e){}
  }

  var finDepth=0;
  function seqDetail(){try{if(typeof W.NSH_seqDetail==='function')return W.NSH_seqDetail()}catch(e){}return null}
  function wrapFinish(){
    if(typeof W.finish!=='function'||W.finish.__v13q)return false;
    var base=W.finish;
    var f=function(opts){
      if(finDepth)return base.apply(this,arguments);   /* v13.14b: a nested copy of this wrapper (see header) does nothing */
      finDepth++;
      try{return fin.apply(this,arguments)}finally{finDepth--}
    };
    var fin=function(opts){
      opts=opts||{};
      if(!opts.restore){try{uidMake()}catch(e){}}
      /* v13.14: in the new display order (assets/nsh-quiz-seq.js) the detail screens come right after the concern screens, before the
         other questions; seq leaves their answers in __nshDPending. Save them now that the answer string is complete, no screens here. */
      if(W.__nshSeqRun&&!opts.restore){var dp=W.__nshDPending||seqDetail();W.__nshDPending=null;if(dp&&Object.keys(dp).length){save(dp);W.__nshDetailDone=ansStr()}else{W.__nshD=null}return base.apply(this,arguments)}
      if(opts.restore||W.__nshDetailOpen||W.__nshDetailDone===ansStr()){return base.apply(this,arguments)}
      var list=detailConcerns();
      if(!list.length){W.__nshD=null;return base.apply(this,arguments)}
      var baseTotal=shownTotal(),total=baseTotal+list.length,d={},i=0,self=this,args=arguments;
      var origST=W.NSH_shownTotal;W.__nshRestoreTotal=function(){W.NSH_shownTotal=origST;W.__nshRestoreTotal=null};
      W.NSH_shownTotal=function(){return total};
      var step=function(){
        if(i>=list.length){W.__nshDetailOpen=0;try{locked=false}catch(e){}if(W.__nshRestoreTotal)W.__nshRestoreTotal();W.__nshDetailDone=ansStr();save(d);return base.apply(self,args)}
        var K=list[i];
        screen(K,baseTotal+i+1,total,function(bits){if(bits===null){W.__nshDetailOpen=0;if(W.__nshRestoreTotal)W.__nshRestoreTotal();return base.apply(self,args)}d[K.code]=bits;i++;step()});
      };
      step();
    };
    f.__v13q=1;W.finish=f;
    return true;
  }
  function wrapShare(){
    if(typeof W.shareUrl!=='function'||W.shareUrl.__v13q)return false;
    var base=W.shareUrl;
    var f=function(){var u=base.apply(this,arguments);try{var d=W.__nshD;if(d){var s=Object.keys(d).map(function(k){return k+String(d[k]||0)}).join('');if(s){var url=new URL(u);url.searchParams.set('d',s);u=url.toString()}}}catch(e){}try{var me=uidGet();if(me){var u2=new URL(u);u2.searchParams.set('by',me);u=u2.toString()}}catch(e){}return u};
    f.__v13q=1;W.shareUrl=f;
    return true;
  }
  /* restore: a shared or own link may carry d= ; keep it on window for the result engine */
  (function(){try{var p=new URL(location.href).searchParams.get('d');if(p){var d={};p.replace(/([A-Z])(\d)/g,function(_,c,n){d[c]=+n});W.__nshD=d}}catch(e){}})();

  var tries=0;
  function boot(){
    var a=reshape(),b=wrapFinish(),c=wrapShare();
    if(!(a&&b&&c)&&tries++<60)setTimeout(boot,150);
  }
  if(D.readyState==='loading')D.addEventListener('DOMContentLoaded',boot);else boot();
})();